import { action } from "typesafe-actions";
import { EstoqueCartTypes, IEstoqueCart, IPagadores} from "./types";

export const addItemRequest = (item: IEstoqueCart[]) =>
  action(EstoqueCartTypes.ADD_ITEM_REQUEST, { item });

export const deleteItemRequest = (data: IEstoqueCart[]) =>
  action(EstoqueCartTypes.DELETE_ITEM_REQUEST, { data });

export const loadRequestCart = (inscricaoAtiva: number | undefined, 
  cddAtivo: number | undefined, codProduto: number | undefined) => 
    action(EstoqueCartTypes.PAGADORES_REQUEST, { inscricaoAtiva, cddAtivo, codProduto });
export const loadSuccessCart = (data: IPagadores) => 
  action(EstoqueCartTypes.PAGADORES_SUCCESS, { data });
export const loadFailureCart = () => action(EstoqueCartTypes.PAGADORES_FAILURE);

export const endSelect = (endereco: {}) => action(EstoqueCartTypes.ENDERECO, { endereco });

export const clearEnd = () => action(EstoqueCartTypes.CLEAR_END);

export const clearCart = () => action(EstoqueCartTypes.CLEAR_CART);